/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsCreateAgent } from "../../funcs/agentsCreateAgent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateAgentRequest$inboundSchema,
};

export const tool$agentsCreateAgent: ToolDefinition<typeof args> = {
  name: "agents-create-agent",
  description: `Create an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentsCreateAgent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
